import './styles/index.scss';

import { DroletButton, ImageBlock, SingleBlog } from '../components/Primitives';
import { GatsbyImage } from 'gatsby-plugin-image';
import { IAppliance, IBlog } from '../interfaces/interfaces';
import React, {
    useCallback,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react';
import { faDownload, faFileImport } from '@fortawesome/free-solid-svg-icons';
import { getBase64, removeWhiteSpaces } from '../utils';

import ApplianceSingle from '../components/Listing/ApplianceSingle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FsLightbox from 'fslightbox-react';
import { Input } from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Primitives';
import Layout from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Layout/Layout';
import SEO from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Seo';
import buttonArrow from '../images/icons/button-arrow.svg';
import camion from '../images/icons/camion.svg';
import dollard from '../images/icons/dollard.svg';
import { feedbackContext } from '@progymedia/gatsby-theme-boutik-ecommerce/src/context/feedback/feedbackContext';
import { graphql } from 'gatsby';
import location from '../images/icons/location.svg';
import useMobileDetect from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/Hooks/useMobileDetect';
import { usePageLocalization } from '@sbi-international/boutik.gatsby.plugin.multilocale';
import { useTranslation } from 'react-i18next';
import GatsbyImageWrapper from '../components/GatsbyImageWrapper';

export const query = graphql`
    query {
        firstSectionCms: allProductsJson(
            filter: { code: { eq: "drolet_accueil-section1" } }
        ) {
            nodes {
                ...cmsDataFragment
                images
                attributes {
                    bouttons {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        findRetailerCms: allProductsJson(
            filter: { code: { eq: "drolet_trouver-detaillant" } }
        ) {
            nodes {
                attributes {
                    content {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                        valuesMarkdownRemark {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        newsSectionCms: allProductsJson(
            filter: { code: { eq: "drolet_accueil-section-new" } }
        ) {
            nodes {
                ...cmsDataFragment
            }
        }
        whoAreWeSection: allProductsJson(
            filter: { code: { eq: "drolet_accueil-section-whoarewe" } }
        ) {
            nodes {
                ...cmsDataFragment
                thumbnail
                thumbnailImage {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED)
                    }
                }
            }
        }
        promoSection: allProductsJson(
            filter: { code: { eq: "drolet_accueil-section-promotions" } }
        ) {
            nodes {
                ...cmsDataFragment
            }
        }
        blogSection: allProductsJson(
            filter: { code: { eq: "drolet_accueil-section-blogs" } }
        ) {
            nodes {
                thumbnail
                thumbnailImage {
                    childImageSharp {
                        gatsbyImageData(layout: CONSTRAINED)
                    }
                }
                ...cmsDataFragment
            }
        }
        myDroletSection: allProductsJson(
            filter: { code: { eq: "drolet_accueil-section-mondrolet" } }
        ) {
            nodes {
                images
                ...cmsDataFragment
            }
        }
        appliances: allProductsJson(
            filter: {
                category: { regex: "^/Drolet/Heaters/" }
                status: { eq: "actif" }
            }
        ) {
            nodes {
                id
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                slug {
                    en_CA
                    en_US
                    fr_CA
                }
                category
                category_localized {
                    en_CA
                    en_US
                    fr_CA
                }
                images
                fields {
                    ...productsFieldsImagesFragment
                    schema {
                        childImageSharp {
                            gatsbyImageData(layout: CONSTRAINED)
                        }
                    }
                }
                attributes {
                    ...productAttributesFragment
                    recent_article {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    size {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    certifications {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        blogs: allProductsJson(
            filter: { category: { eq: "/Drolet/CMS/Blog/" } }
        ) {
            nodes {
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                code
                attributes {
                    content {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                        valuesMarkdownRemark {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    blog_date {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
                fields {
                    ...productsFieldsImagesFragment
                }
                slug {
                    en_CA
                    en_US
                    fr_CA
                }
            }
        }
        metadata: allProductsJson(filter: { code: { eq: "drolet_accueil" } }) {
            nodes {
                code
                attributes {
                    meta_title {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    meta_description {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
        sliders: allProductsJson(
            filter: { code: { regex: "/^drolet_accueil-slider/" } }
        ) {
            nodes {
                code
                title {
                    en_CA
                    en_US
                    fr_CA
                }
                description {
                    en_CA
                    en_US
                    fr_CA
                }
                fields {
                    ...productsFieldsImagesFragment
                }
                attributes {
                    bouttons {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                    url {
                        values {
                            en_CA
                            en_US
                            fr_CA
                        }
                    }
                }
            }
        }
    }
`;

export default function Index({ data }) {
    const { currentLocale, navigateTranslated } = usePageLocalization();
    const { t } = useTranslation('pages');
    const promoCms = data?.promoSection.nodes[0];
    const isMobile = useMobileDetect().isMobile();
    const metadataAttributes = data?.metadata?.nodes[0]?.attributes;
    const metadata = {
        title: metadataAttributes?.meta_title?.values[0][currentLocale],
        description:
            metadataAttributes?.meta_description?.values[0][currentLocale],
    };
    const newsCMS = data?.findRetailerCms?.nodes[0];
    const SCREEN_SLIDER_TRIGGER = 100;

    return (
        <Layout>
            <SEO title={metadata?.title} description={metadata?.description} />
            <div className='home-page container'>
                <FirstSection />
                <NewsSection newsCMS={newsCMS} />
                <WhoAreWeSection />

                <ImageBlock
                    subtitle={
                        promoCms?.attributes?.texte_1?.values?.[0]?.[
                            currentLocale
                        ]
                    }
                    title={promoCms?.title?.[currentLocale]}
                    image={
                        promoCms?.fields?.images[0]?.childImageSharp
                            ?.gatsbyImageData
                    }
                    content={
                        promoCms?.attributes?.content?.values?.[0]?.[
                            currentLocale
                        ]
                    }
                >
                    <span
                        className='home-see-promo'
                        onClick={() => {
                            navigateTranslated('/promotions');
                        }}
                    >
                        {t('home.see-promo')}
                    </span>
                </ImageBlock>

                <BlogSection />
                <MyDroletSection />
            </div>
        </Layout>
    );

    function FirstSection() {
        const currentCms = data?.firstSectionCms.nodes[0];
        const responsiveImages = currentCms?.fields;
        const desktopImage =
            responsiveImages?.banniere_desktop?.[0]?.childImageSharp
                ?.gatsbyImageData;
        const mobileImage =
            responsiveImages?.banniere_mobile?.[0]?.childImageSharp
                ?.gatsbyImageData;
        const icons = responsiveImages?.images;
        const sliders = data.sliders.nodes;
        const [sliderPos, setSliderPos] = useState<number>(0);
        const [startSwipe, setStartSwipe] = useState<number>(0);
        const [endSwipe, setEndSwipe] = useState<number>(0);
        const [showShippingTooltip, setShowTooltip] = useState<boolean>(false);
        const [currentIconIndex, setCurrentIconIndex] = useState<number>(0);

        const { currentLocale } = usePageLocalization();

        const texte2hover: string =
            currentCms?.attributes?.texte_2?.values?.[0]?.[
                currentLocale
            ].replace('*', `<span>*</span>`);

        function handleSwipe() {
            if (endSwipe - startSwipe > SCREEN_SLIDER_TRIGGER) {
                if (sliderPos - 1 >= 0) setSliderPos(sliderPos - 1);
            }
            if (endSwipe - startSwipe < -SCREEN_SLIDER_TRIGGER) {
                if (sliderPos + 1 < sliders.length) setSliderPos(sliderPos + 1);
            }
        }
        useEffect(() => {
            handleSwipe();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [endSwipe]);

        icons?.forEach(
            (element: { [x: string]: any }, index: string | number) => {
                element['name'] = currentCms.images[index];
            }
        );

        useEffect(() => {
            const newIconIndex =
                currentLocale === 'fr_CA'
                    ? icons?.findIndex((icon: { name: string | string[] }) =>
                          icon.name.includes('frca')
                      )
                    : currentLocale === 'en_CA'
                    ? icons?.findIndex((icon: { name: string | string[] }) =>
                          icon.name.includes('enca')
                      )
                    : icons?.findIndex((icon: { name: string | string[] }) =>
                          icon.name.includes('enus')
                      );

            setCurrentIconIndex(newIconIndex);
        }, [currentLocale]);

        return (
            <div className='home-section1'>
                {(mobileImage || desktopImage) && (
                    <GatsbyImage
                        className='section1-bg'
                        image={isMobile ? mobileImage : desktopImage}
                        alt=''
                    />
                )}
                <div
                    className='home-section-content'
                    onTouchStart={(e) => {
                        setStartSwipe(e?.changedTouches[0].screenX);
                    }}
                    onTouchEnd={(e) => {
                        setEndSwipe(e?.changedTouches[0].screenX);
                    }}
                >
                    <div className='section1-content'>
                        <h1 className='section-title'>
                            {sliders[sliderPos]?.title?.[currentLocale] || ''}
                        </h1>
                        <span className='line' />
                        <div className='section-content'>
                            <span className='section-text'>
                                {
                                    sliders[sliderPos]?.description?.[
                                        currentLocale
                                    ]
                                }
                            </span>
                            <DroletButton
                                label={
                                    sliders[sliderPos]?.attributes?.bouttons
                                        ?.values[0]?.[currentLocale]
                                }
                                link={
                                    sliders[sliderPos]?.attributes?.url
                                        ?.values[0]?.[currentLocale]
                                }
                            />
                        </div>
                    </div>
                    <GatsbyImageWrapper
                        className='section1-img-single'
                        fields={sliders?.[sliderPos]?.fields}
                    />
                </div>
                <div className='home-buttons'>
                    <img
                        className='left'
                        src={buttonArrow}
                        alt=''
                        onClick={() => {
                            if (sliderPos - 1 >= 0) setSliderPos(sliderPos - 1);
                        }}
                    />
                    <img
                        className='right'
                        src={buttonArrow}
                        alt=''
                        onClick={() => {
                            if (sliderPos + 1 < sliders.length)
                                setSliderPos(sliderPos + 1);
                        }}
                    />
                </div>
                <div className='home-separator'>
                    <div className='separator-section'>
                        <GatsbyImageWrapper
                            className='img'
                            fields={currentCms?.fields}
                            imageIndex={currentIconIndex}
                        />
                        <span className='section'>
                            {
                                currentCms?.attributes?.texte_1?.values?.[0]?.[
                                    currentLocale
                                ]
                            }
                        </span>
                    </div>
                    <span className='line'></span>
                    <div className='separator-section'>
                        <img src={camion} alt='' />
                        <div
                            style={{
                                display: showShippingTooltip ? 'block' : 'none',
                            }}
                            className='hover'
                        >
                            {t('home.shipping-tooltip')}
                        </div>
                        <span className='section'>
                            <div
                                className='text'
                                onMouseEnter={() => setShowTooltip(true)}
                                onMouseLeave={() => setShowTooltip(false)}
                                dangerouslySetInnerHTML={{
                                    __html: texte2hover,
                                }}
                            ></div>
                        </span>
                    </div>
                    <span className='line'></span>

                    <div className='separator-section'>
                        <img src={dollard} alt='' />
                        <span className='section'>
                            {
                                currentCms?.attributes?.texte_3?.values?.[0]?.[
                                    currentLocale
                                ]
                            }
                        </span>
                    </div>
                </div>
            </div>
        );
    }

    function NewsSection(props: { newsCMS: any }) {
        const { newsCMS } = props;
        const currentCms = data?.newsSectionCms.nodes[0];
        const appliances = data?.appliances.nodes;
        const [postalCode, setPostalCode] = useState('');
        const recents = appliances.filter(
            (appliance: {
                attributes: { recent_article: { values: { en_CA: string }[] } };
            }) =>
                appliance?.attributes?.recent_article?.values?.[0]?.en_CA ===
                'Yes'
        );
        const isTablet = useMobileDetect().isTablet();
        const [page, setPage] = useState(1);
        const APPLIANCE_PER_PAGE = isMobile && !isTablet ? 1 : 2;
        const [startSwipe, setStartSwipe] = useState(0);
        const [endSwipe, setEndSwipe] = useState(0);

        const searchRetailer = useCallback(
            (value?: string) => {
                if ((!value || value === 'Enter') && postalCode.trim() !== '') {
                    const trimmedCode = removeWhiteSpaces(postalCode);
                    navigateTranslated(
                        `/where-to-buy/?searchValue=${encodeURI(trimmedCode)}`
                    );
                }
            },
            [postalCode]
        );
        const setNext = () => {
            const pageNumber = Math.ceil(recents.length / APPLIANCE_PER_PAGE);
            if (page !== pageNumber) setPage(page + 1);
            else setPage(1);
        };
        const setPrevious = () => {
            const pageNumber = Math.ceil(recents.length / APPLIANCE_PER_PAGE);
            if (page !== 1) setPage(page - 1);
            else setPage(pageNumber);
        };
        function handleSwipe() {
            if (endSwipe - startSwipe > SCREEN_SLIDER_TRIGGER) {
                setPrevious();
            }
            if (endSwipe - startSwipe < -SCREEN_SLIDER_TRIGGER) {
                setNext();
            }
        }

        useEffect(() => {
            handleSwipe();
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [endSwipe]);
        return (
            <div className='news-section'>
                <div className='content'>
                    <div className='text'>
                        <span className='section-subtitle'>
                            {currentCms?.attributes?.texte_1?.values?.[0]?.[
                                currentLocale
                            ] || ''}
                        </span>
                        <span className='section-title'>
                            {currentCms?.attributes?.texte_2?.values?.[0]?.[
                                currentLocale
                            ] || ''}
                        </span>
                        <span className='line'></span>
                        <span className='content-content'>
                            {currentCms?.attributes?.content?.values?.[0]?.[
                                currentLocale
                            ] || ''}
                        </span>
                    </div>
                    <div
                        className='stoves'
                        onTouchStart={(e) => {
                            setStartSwipe(e?.changedTouches[0].screenX);
                        }}
                        onTouchEnd={(e) => {
                            setEndSwipe(e?.changedTouches[0].screenX);
                        }}
                    >
                        {recents
                            ?.slice(
                                APPLIANCE_PER_PAGE * (page - 1),
                                APPLIANCE_PER_PAGE * page
                            )
                            ?.map((recent: IAppliance, index: React.Key) => {
                                return (
                                    <ApplianceSingle
                                        key={`appSingle${index}`}
                                        appliance={recent}
                                        id={`appliance-single-${index}`}
                                    />
                                );
                            })}
                    </div>
                </div>
                <div className='buttons'>
                    <img
                        className='left'
                        src={buttonArrow}
                        alt=''
                        onClick={() => setPrevious()}
                    ></img>
                    <img
                        className='right'
                        src={buttonArrow}
                        alt=''
                        onClick={() => setNext()}
                    ></img>
                </div>{' '}
                <div className='where-to-buy-container'>
                    <div className='where-to-buy'>
                        <span className='retailer-location'>
                            <img src={location} alt=''></img>
                        </span>
                        <div className='retailer-text'>
                            <span className='retailer-title'>
                                {
                                    newsCMS?.attributes?.content?.values?.[0][
                                        currentLocale
                                    ]
                                }
                            </span>
                            <span className='line'></span>
                        </div>
                        <div className='retailer-component'>
                            <div className='input-wrapper'>
                                <Input
                                    placeholder={t('home.postal-code')}
                                    className='postal-code'
                                    onChange={(value) => {
                                        setPostalCode(value);
                                    }}
                                    onKeyDown={(value) => {
                                        searchRetailer(value);
                                    }}
                                ></Input>
                                <img
                                    className='postal-code-btn'
                                    src={buttonArrow}
                                    alt=''
                                    onClick={() => searchRetailer()}
                                ></img>
                            </div>
                            <DroletButton
                                label={t('home.use-my-position')}
                                onClick={() => {
                                    navigateTranslated('/where-to-buy/');
                                }}
                            ></DroletButton>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    function WhoAreWeSection() {
        const currentCms = data?.whoAreWeSection.nodes[0];

        return (
            <div className='who-are-we-section'>
                {currentCms?.thumbnail && (
                    <img
                        className='section-bg'
                        alt=''
                        src={`/file/${currentCms?.thumbnail[0]}`}
                    />
                )}
                <div className='content'>
                    <span className='section-subtext'>
                        {currentCms?.attributes?.texte_1?.values?.[0]?.[
                            currentLocale
                        ] || ''}
                    </span>
                    <span className='section-title'>
                        {currentCms?.title?.[currentLocale] || ''}
                    </span>
                    <span className='line'></span>
                    <span className='text'>
                        {currentCms?.attributes?.content?.values?.[0]?.[
                            currentLocale
                        ] || ''}
                    </span>
                    <span
                        className='learn-more'
                        onClick={() => {
                            navigateTranslated('/about');
                        }}
                    >
                        {t('home.learn-more')}
                    </span>
                </div>
            </div>
        );
    }
    function BlogSection() {
        const currentCms = data?.blogSection.nodes[0];

        let blogs: IBlog[] = data?.blogs?.nodes;
        blogs = blogs.slice(0, 2);
        return (
            <div className='blog-section'>
                {currentCms.thumbnailImage && (
                    <GatsbyImage
                        alt=''
                        className='blog-img-bg'
                        image={
                            currentCms.thumbnailImage?.childImageSharp
                                ?.gatsbyImageData
                        }
                    />
                )}
                <div className='content'>
                    <span className='subtitle'>
                        {currentCms?.attributes?.texte_1?.values?.[0]?.[
                            currentLocale
                        ] || ''}
                    </span>
                    <span className='section-title'>
                        {currentCms?.title?.[currentLocale]}
                    </span>
                    <span className='blog-line'></span>
                    <span className='text'>
                        {currentCms?.attributes?.content?.values?.[0]?.[
                            currentLocale
                        ] || ''}
                    </span>
                    <div className='blogs-flex'>
                        <div className='blogs'>
                            {blogs
                                .sort((a, b) => {
                                    const dateA = new Date(
                                        a.attributes.blog_date.values[0].en_CA
                                    );
                                    const dateB = new Date(
                                        b.attributes.blog_date.values[0].en_CA
                                    );
                                    return dateB.getTime() - dateA.getTime(); // tri décroissant
                                })
                                .map((blog, index) => {
                                    return (
                                        <SingleBlog blog={blog} key={index} />
                                    );
                                })}
                            <DroletButton
                                label={t('home.see-all-articles')}
                                onClick={() => {
                                    navigateTranslated('/blogArchives');
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    function MyDroletSection() {
        const [isLightBoxVisible, setIsLightBoxVisible] = useState(false);
        const { addAlert } = useContext(feedbackContext);
        const [uploadedImage, setUploadedImage] = useState(undefined);
        const currentCms = data?.myDroletSection.nodes[0];
        const imgRef = useRef(null);
        const previewRef = useRef(null);
        const [fileName, setFileName] = useState('');
        const [fileType, setFileType] = useState('');

        const getImagesSrc = () =>
            currentCms?.images?.map((image: string) => `/file/${image}`);

        const uploadImage = useCallback(async () => {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    site: 'www.drolet.ca',
                    filedata: uploadedImage,
                    filename: fileName,
                    filetype: fileType,
                }),
            };
            const response = await fetch('/inquiry/mondrolet', requestOptions);

            if (response.ok) {
                addAlert({
                    message: t('toastMessages:mondrolet-success'),
                    status: 'success',
                });
            } else {
                addAlert({
                    message: t('toastMessages:mondrolet-error'),
                    status: 'error',
                });
            }
            setUploadedImage(undefined);
            setFileName('');
            setFileType('');
            previewRef?.current?.setAttribute('src', undefined);
        }, [addAlert, fileName, fileType, uploadedImage]);

        return (
            <div className='mondrolet-section'>
                <div className='my-drolet'>
                    <span className='section-title'>
                        {currentCms?.title?.[currentLocale]}
                    </span>
                    <span className='content'>
                        {' '}
                        {currentCms?.attributes?.content?.values?.[0]?.[
                            currentLocale
                        ] || ''}
                    </span>
                </div>
                <div className='my-drolet-img-container'>
                    {getImagesSrc().map((imageSrc: string, index: number) => {
                        return (
                            <div
                                key={`myDroletItem${index}`}
                                className='mydrolet-img-single'
                                onClick={() =>
                                    setIsLightBoxVisible(!isLightBoxVisible)
                                }
                            >
                                <img alt='' src={imageSrc} />
                            </div>
                        );
                    })}
                    <FsLightbox
                        toggler={isLightBoxVisible}
                        exitFullscreenOnClose={true}
                        sources={getImagesSrc()}
                    />
                    <div
                        className='add-your-drolet mydrolet-img-single'
                        onClick={() => {
                            imgRef?.current?.click();
                        }}
                    >
                        <form action='' style={{ display: 'none' }}>
                            <input
                                onChange={async () => {
                                    const files = imgRef.current.files;

                                    if (files.length > 0) {
                                        const base64 = await getBase64(
                                            files[0]
                                        );
                                        setUploadedImage(base64);
                                        setFileName(files[0]?.name);
                                        setFileType(files[0]?.type);
                                    }

                                    previewRef?.current?.setAttribute(
                                        'src',
                                        URL.createObjectURL(files[0])
                                    );
                                }}
                                type='file'
                                accept={'.jpg, .pdf, .png'}
                                id='mydrolet-fileinput'
                                ref={imgRef}
                            />
                        </form>

                        {uploadedImage ? (
                            <img
                                id='image-preview'
                                src=''
                                alt=''
                                ref={previewRef}
                            />
                        ) : (
                            <span className='preview-txt'>
                                {t('home.add-picture')}
                            </span>
                        )}

                        {uploadedImage ? (
                            <>
                                <span
                                    className='upload-image'
                                    onClick={(event) => {
                                        event.stopPropagation();
                                        uploadImage();
                                    }}
                                >
                                    {t('home.send-image')}
                                    <FontAwesomeIcon
                                        className='drolet-icon'
                                        icon={faFileImport}
                                    />
                                </span>
                            </>
                        ) : (
                            <FontAwesomeIcon
                                className='drolet-icon'
                                icon={faDownload}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}
